// extracted by mini-css-extract-plugin
export default {"input":"input_input__itj39","label":"input_label__cibwp","error":"input_error__YqmIx"};